export function FileToBase64(inputFile) {
  const temporaryFileReader = new FileReader();

  return new Promise((resolve, reject) => {
    temporaryFileReader.onerror = () => {
      temporaryFileReader.abort();
      reject(new DOMException("Problem parsing input file."));
    };

    temporaryFileReader.onload = () => {
      resolve(temporaryFileReader.result);
    };
    temporaryFileReader.readAsDataURL(inputFile);
  });
}

export function RemoveFormatFromBase64(input) {
  try {
    let splited = input.split(',');
    if (splited[1].length > 1) {
      return splited[1];
    }
  } catch (e) {
    new DOMException("Problem spliting Data/DataType");
  }
  return "error";
}



// WEBPACK FOOTER //
// ./src/utils/fileUtils.js